import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FooterText } from "../components/footer/FooterText";

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(8, 0, 2),
  },
  section: {
    marginTop: theme.spacing(3),
  },
  list: {
    margin: 0,
    paddingLeft: theme.spacing(3),
  },
  homeLink: {
    color: theme.palette.foreground.default,
    textDecoration: "none",
    transition: "color 0.3s ease",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
}));

export const LegalPage = () => {
  const classes = useStyles();

  return (
    <Box className={classes.page}>
      <Container maxWidth="md">
        <Typography variant="body2" paragraph>
          <RouterLink to="/" className={classes.homeLink}>
            Back to Home
          </RouterLink>
        </Typography>
        <Typography variant="h3" component="h1" gutterBottom>
          Legal
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Last updated: 4 June 2026
        </Typography>

        <Box className={classes.section}>
          <Typography variant="body1" paragraph>
            This Legal page applies to the Hulmify landing website and all
            Hulmify applications, products, and services that link to this page.
            By accessing or using any Hulmify app, you agree to these terms and
            notices.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            1. Terms of Use
          </Typography>
          <Typography variant="body1" paragraph>
            You may use the Services only in compliance with applicable laws and
            these terms. You agree not to misuse the Services, interfere with
            operation or security, or attempt unauthorized access.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            2. Intellectual Property
          </Typography>
          <Typography variant="body1" paragraph>
            Unless stated otherwise, the Services, including software, branding,
            text, designs, graphics, and content, are owned by Hulmify or its
            licensors and are protected by applicable intellectual property
            laws. No rights are granted except as expressly stated.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            3. Third-Party Services and Links
          </Typography>
          <Typography variant="body1" paragraph>
            Hulmify apps may reference or integrate third-party services. We are
            not responsible for third- party websites, products, or policies.
            Your use of third-party services is subject to their terms.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            4. Disclaimer of Warranties
          </Typography>
          <Typography variant="body1" paragraph>
            The Services are provided on an "as is" and "as available" basis to
            the fullest extent permitted by law, without warranties of any kind,
            express or implied, including merchantability, fitness for a
            particular purpose, and non-infringement.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            5. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            To the maximum extent permitted by law, Hulmify and its affiliates
            will not be liable for indirect, incidental, special, consequential,
            or punitive damages, or loss of profits, data, goodwill, or business
            interruption arising from use of the Services.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            6. Indemnification
          </Typography>
          <Typography variant="body1" paragraph>
            You agree to defend, indemnify, and hold harmless Hulmify and its
            affiliates from claims, liabilities, losses, and expenses arising
            from your misuse of the Services, violation of these terms, or
            violation of applicable law.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            7. Compliance and Acceptable Use
          </Typography>
          <Typography variant="body1" paragraph>
            Users must comply with all applicable laws, including privacy,
            consumer protection, sanctions, export controls, anti-corruption,
            and intellectual property laws. Hulmify may suspend access where
            required to protect users, systems, or legal compliance.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            8. Copyright and Takedown Notices
          </Typography>
          <Typography variant="body1" paragraph>
            If you believe content in any Hulmify app infringes your rights,
            send a notice through the contact channels on this website with
            sufficient detail to identify the work and alleged infringement so
            we can review and respond.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            9. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These terms are governed by the laws applicable to the Hulmify
            operating entity providing the relevant Service, without regard to
            conflict of law principles, subject to non-waivable local consumer
            rights.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            10. Changes to Legal Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We may modify these terms as products and laws evolve. Updated
            versions will be posted here with a revised "Last updated" date.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            11. Contact
          </Typography>
          <Typography variant="body1" paragraph>
            For legal notices or questions covering any Hulmify app, contact us
            via the channels listed on this website and include "Legal Notice"
            in your message.
          </Typography>
        </Box>

        <Box className={classes.section}>
          <Typography variant="h6" gutterBottom>
            12. Related Policy
          </Typography>
          <ul className={classes.list}>
            <li>
              <Typography variant="body1">
                Privacy Policy for all Hulmify apps is available at
                /privacy-policy.
              </Typography>
            </li>
          </ul>
        </Box>
      </Container>
      <FooterText />
    </Box>
  );
};
